import axios from "axios";
/// Function to fetch data
export const fetchData = async () => {
  try {
    const response = await axios.get(
      `https://partners.payhere.lk/dashboard/web-data.json`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
